<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{translate?.general.buttons.import.singular}} {{translate?.setup.users.shifts.sections.sec1.plural}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close"
            [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body">
        <!-- Step 1: Download Template -->
        <div class="bulk-shift-import__step">
            <div class="bulk-shift-import__step-label">{{translate?.setup.users.shifts.sections.sec4.singular}}</div>
            <p-button
                type="button"
                [label]="translate?.general.buttons.download.singular + ' Template (.csv)'"
                icon="fa-regular fa-arrow-down-to-line"
                styleClass="h-32"
                (onClick)="onDownloadTemplate()">
            </p-button>

            <span class="bulk-shift-import__hint">
                {{translate?.setup.users.shifts.messages.importColumnsHint}}
            </span>
        </div>

        <!-- Step 2: Upload Completed File -->
        <div class="bulk-shift-import__step">
            <div class="bulk-shift-import__step-label">{{translate?.setup.users.shifts.sections.sec5.singular}}</div>

            <div class="bulk-shift-import__upload-row">
                <div class="bulk-shift-import__filename">
                    {{ uploadedFileName || translate?.setup.users.shifts.messages.noFileSelected }}
                </div>
                <p-button
                    type="button"
                    [label]="translate?.general.buttons.choose.singular + ' File'"
                    icon="fa-regular fa-plus"
                    styleClass="h-32"
                    (onClick)="fileInput.click()">
                </p-button>

                <input
                    #fileInput
                    type="file"
                    accept=".csv,text/csv"
                    hidden
                    (change)="onFileSelected($event)" />
            </div>

            <span class="bulk-shift-import__hint">{{translate?.setup.users.shifts.validationFE.csvOnlyHint}}</span>
        </div>

        <!-- Step 3: Validation Preview -->
        <div class="bulk-shift-import__step" *ngIf="validationRows.length > 0">
            <div class="bulk-shift-import__step-label">{{translate?.setup.users.shifts.sections.sec6.singular}}</div>

            <div class="bulk-shift-import__table-wrap">
                <p-table [value]="validationRows" styleClass="mp-status-table" tableStyleClass="bulk-shift-import__table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{translate?.setup.users.shifts.fields.row.singular}}</th>
                            <th>{{translate?.setup.users.shifts.fields.identifier.singular}}</th>
                            <th>{{translate?.setup.users.shifts.label.singular}} {{translate?.setup.users.shifts.fields.code.singular}}</th>
                            <th>{{translate?.setup.users.shifts.fields.start.singular}}</th>
                            <th>{{translate?.setup.users.shifts.fields.end.singular}}</th>
                            <th>{{translate?.setup.users.shifts.fields.result.singular}}</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.rowNumber }}</td>
                            <td [title]="row.identifier">{{ row.identifier }}</td>
                            <td class="bulk-shift-import__cell-nowrap">{{ row.shiftCode || '—' }}</td>
                            <td class="bulk-shift-import__cell-nowrap">{{ row.start || '—' }}</td>
                            <td class="bulk-shift-import__cell-nowrap">{{ row.end || '—' }}</td>
                            <td>
                                <span
                                    class="status-pill-long"
                                    [ngClass]="row.isValid ? 'is-active' : 'is-leave-active'"
                                    [title]="row.isValid ? translate?.setup.users.shifts.fields.valid.singular : (row.errorReason || translate?.setup.users.shifts.fields.error.singular)">
                                    <i class="fa-regular" [ngClass]="row.isValid ? 'fa-circle-check' : 'fa-circle-xmark'"></i>
                                    {{ row.isValid ? translate?.setup.users.shifts.fields.valid.singular : row.errorReason }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <!-- Step 4: Confirm & Apply -->
        <div class="bulk-shift-import__step" *ngIf="validationRows.length > 0">
            <div class="bulk-shift-import__step-label">{{translate?.setup.users.shifts.sections.sec7.singular}}</div>

            <span
                class="bulk-shift-import__hint"
                [ngClass]="{
                    'is-success': confirmApplyStatus === 'success',
                    'is-partial': confirmApplyStatus === 'partial',
                    'is-failed': confirmApplyStatus === 'failed'
                }">
                {{ confirmApplyMessage }}
            </span>

            <div class="bulk-shift-import__actions">
                <p-button
                    type="button"
                    [label]="'Confirm & Apply ' + translate?.setup.users.shifts.fields.valid.singular + ' ' + translate?.setup.users.shifts.fields.row.plural"
                    styleClass="h-32"
                    [disabled]="validCount === 0 || applying"
                    (onClick)="onConfirmApply()">
                </p-button>

                <p-button
                    type="button"
                    styleClass="h-32 dark"
                    [label]="translate?.general.buttons.download.singular + ' ' + translate?.setup.users.shifts.fields.error.singular + ' Report'"
                    (onClick)="onDownloadErrorReport()"
                    [disabled]="errorCount === 0">
                </p-button>
            </div>
        </div>
    </div>

    <div class="flx-modal__footer">
        <button class="custella-btn-white" (click)="onCancelImport()">
            {{ translate?.general.buttons.cancel.singular || 'Cancel' }}
        </button>
    </div>
</div>
